if (!window.gridAtcInit) {
  window.gridAtcInit = true;

  // Mål højden på en farve-række og giv kort uden farver præcis samme luft
  // (sammenligner hvor knappen står på et kort med farver og et kort uden)
  var gridSwatchesHeight = function () {
    var infos = document.querySelectorAll('.product-item__info');
    var withRow = null;
    var withSpacer = null;
    for (var i = 0; i < infos.length && !(withRow && withSpacer); i++) {
      var info = infos[i];
      if (!info.querySelector('[data-grid-atc]') || !info.offsetHeight) continue;
      if (!withSpacer && info.querySelector('.product-item__swatches-spacer')) withSpacer = info;
      else if (!withRow && !info.querySelector('.product-item__swatches-spacer')) withRow = info;
    }
    if (!withRow || !withSpacer) return;

    var offset = function (info) {
      return info.querySelector('[data-grid-atc]').getBoundingClientRect().top - info.getBoundingClientRect().top;
    };
    var spacer = withSpacer.querySelector('.product-item__swatches-spacer');
    var diff = offset(withRow) - offset(withSpacer);
    if (Math.abs(diff) < 1) return;
    var height = Math.max(0, spacer.offsetHeight + diff);
    document.documentElement.style.setProperty('--grid-swatches-height', height + 'px');
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', gridSwatchesHeight);
  } else {
    gridSwatchesHeight();
  }
  window.addEventListener('load', gridSwatchesHeight);
  window.addEventListener('resize', gridSwatchesHeight);

  var gridAtcLabel = function (form) {
    var select = form.querySelector('[data-grid-atc-select]');
    var option = select ? select.options[select.selectedIndex] : null;
    var isPreorder = option ? option.dataset.preorder === 'true' : false;
    return isPreorder ? form.dataset.labelPreorder : form.dataset.labelAdd;
  };

  // Skift knaptekst når man vælger en størrelse der er til forudbestilling
  document.addEventListener('change', function (e) {
    var select = e.target.closest('[data-grid-atc-select]');
    if (!select) return;
    var form = select.closest('[data-grid-atc]');
    form.querySelector('[data-grid-atc-label]').textContent = gridAtcLabel(form);
    form.querySelector('[data-grid-atc-error]').hidden = true;
    form.classList.remove('is-missing-size');

    // Rund "+"-knap (3. nov. 2026): størrelsesvalget ligger usynligt over knappen.
    // Så snart kunden har valgt en størrelse, lægges varen i kurven - ingen ekstra tryk.
    if (form.hasAttribute('data-hh-plus') && select.value) {
      if (typeof form.requestSubmit === 'function') form.requestSubmit();
      else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    }
  });

  // Rund "+"-knap (3. nov. 2026): "+" åbner et lille kort over billedet med de størrelser,
  // der er på lager. Et tryk på en størrelse lægger varen i kurven med det samme.
  // Kortet (data-hh-panel) ligger lige efter formularen. Kun ét kort er åbent ad gangen.
  var hhPanel = function (form) {
    var p = form.nextElementSibling;
    return p && p.hasAttribute('data-hh-panel') ? p : null;
  };

  var hhAaben = function (form, aaben) {
    var panel = hhPanel(form);
    var toggle = form.querySelector('[data-hh-toggle]');
    form.classList.toggle('is-open', aaben);
    if (panel) {
      panel.classList.toggle('is-open', aaben);
      if (!aaben) {
        panel.classList.remove('is-done');
        var titel = panel.querySelector('[data-hh-titel]');
        if (titel) titel.textContent = titel.getAttribute('data-hh-titel');
      }
    }
    if (toggle) toggle.setAttribute('aria-expanded', aaben ? 'true' : 'false');
  };

  var hhLuk = function (undtagen) {
    document.querySelectorAll('[data-hh-plus].is-open').forEach(function (f) {
      if (f !== undtagen) hhAaben(f, false);
    });
  };

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-hh-toggle]');
    if (toggle) {
      e.preventDefault();
      var form = toggle.closest('[data-grid-atc]');
      var aaben = !form.classList.contains('is-open');
      hhLuk(form);
      hhAaben(form, aaben);
      return;
    }

    var size = e.target.closest('[data-hh-size]');
    if (size) {
      e.preventDefault();
      var panel = size.closest('[data-hh-panel]');
      var f = panel ? panel.previousElementSibling : null;
      if (!f || !f.hasAttribute('data-grid-atc') || f.classList.contains('is-loading')) return;
      f.querySelector('[data-hh-id]').value = size.getAttribute('data-hh-size');
      if (typeof f.requestSubmit === 'function') f.requestSubmit();
      else f.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
      return;
    }

    // Klik et andet sted lukker kortet
    if (!e.target.closest('[data-hh-panel]')) hhLuk(null);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hhLuk(null);
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-grid-atc]');
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation(); // Undgå dobbelt GA4-hit: Googles auto-detektion må ikke se dette submit

    var button = form.querySelector('[data-grid-atc-button]');
    var label = form.querySelector('[data-grid-atc-label]');
    var error = form.querySelector('[data-grid-atc-error]');
    var select = form.querySelector('[data-grid-atc-select]');
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    // Ingen forvalgt størrelse (1. nov. 2026): der lægges intet i kurven, før kunden har valgt
    if (select && !select.value) {
      error.textContent = 'Vælg en størrelse';
      error.hidden = false;
      form.classList.add('is-missing-size');
      try {
        if (typeof select.showPicker === 'function') select.showPicker();
        else select.focus();
      } catch (err) {
        select.focus();
      }
      return;
    }

    var variantId = parseInt(form.querySelector('[name="id"]').value, 10);
    if (!variantId) {
      error.textContent = 'Vælg en størrelse';
      error.hidden = false;
      return;
    }

    error.hidden = true;
    button.disabled = true;
    form.classList.add('is-loading');

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error(data.description || data.message || 'Kunne ikke tilføje til kurven');
          return data;
        });
      })
      .then(function () {
        // Bed temaet opdatere kurven, og opdater antallet i headeren
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
        label.textContent = form.dataset.labelAdded + ' ✓';
        form.classList.add('is-added');
        // "+"-knappen: kortet siger, at varen ligger i kurven, og lukker sig selv
        var hhP = form.hasAttribute('data-hh-plus') ? hhPanel(form) : null;
        if (hhP && hhP.classList.contains('is-open')) {
          var hhTitel = hhP.querySelector('[data-hh-titel]');
          if (hhTitel) hhTitel.textContent = 'Den ligger i kurven';
          hhP.classList.add('is-done');
          setTimeout(function () {
            hhAaben(form, false);
          }, 1400);
        }
        // "+"-knappen: vis et flueben i 2 sek., og nulstil størrelsen, så samme størrelse kan vælges igen
        if (form.hasAttribute('data-hh-plus') && select && select.querySelector('option[value=""]')) {
          select.selectedIndex = 0;
        }
        setTimeout(function () {
          label.textContent = gridAtcLabel(form);
          form.classList.remove('is-added');
        }, 2000);
      })
      .catch(function (err) {
        error.textContent = err.message;
        error.hidden = false;
      })
      .finally(function () {
        button.disabled = false;
        form.classList.remove('is-loading');
      });
  }, true);

  // Billeder på produktkortet (4. nov. 2026): kun det første billede hentes med siden. De næste hentes,
  // når kunden holder musen over kortet (computer) eller rører ved det (telefon), så siden ikke bliver
  // langsommere. Billedet skifter kun, når kunden selv trykker på en pil eller swiper. Små prikker i
  // bunden (.hh-prikker) viser, hvor mange billeder der er, og hvilket man ser.
  var hhPrikker = function (hover, idx) {
    hover.querySelectorAll('.hh-prikker span').forEach(function (p, i) {
      p.classList.toggle('is-active', i === idx);
    });
  };
  var hhFlickity = function (hover) {
    var F = window.theme && window.theme.Flickity;
    var slider = hover.querySelector('[data-hover-slider]');
    return F && slider ? F.data(slider) : null;
  };
  var hhVisBilleder = function (kort) {
    var hover = kort.querySelector('hover-images');
    if (!hover || !hover.getClientRects().length) return; // skjult, fx i en produkt-slider på telefon
    if (!kort.hhHentet) {
      kort.hhHentet = true;
      hover.querySelectorAll('img[data-hh-src]').forEach(function (img) {
        if (img.dataset.hhSrcset) img.srcset = img.dataset.hhSrcset;
        img.src = img.dataset.hhSrc;
        img.removeAttribute('data-hh-src');
      });
    }
    var flkty = hhFlickity(hover);
    if (flkty && !hover.hhLytter) {
      hover.hhLytter = true;
      flkty.on('select', function () {
        hhPrikker(hover, flkty.selectedIndex);
      });
    }
    // Computer: pile og prikker vises først, når det første billede er klar (intet hvidt blink)
    if (hover.classList.contains('hh-klar')) return;
    var img1 = hover.querySelector('.product-item__bg__slide img');
    var klar = function () {
      hover.classList.add('hh-klar');
    };
    if (!img1 || (img1.complete && img1.naturalWidth)) klar();
    else img1.addEventListener('load', klar, { once: true });
  };

  var hhHoverKort = null;
  var hhHoverTimer = null;
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse') return;
    var kort = e.target.closest ? e.target.closest('.double__image') : null;
    if (kort === hhHoverKort) return;
    // Musen forlod et kort: næste gang starter det igen ved det første billede
    if (hhHoverKort) {
      var forrige = hhHoverKort.querySelector('hover-images');
      var f0 = forrige ? hhFlickity(forrige) : null;
      if (f0 && f0.selectedIndex !== 0) f0.select(0, false, true);
    }
    hhHoverKort = kort;
    clearTimeout(hhHoverTimer);
    // Lille pause, så kort, musen bare passerer, ikke henter billeder
    if (kort) hhHoverTimer = setTimeout(function () { hhVisBilleder(kort); }, 120);
  });
  // Telefon: swipe på billedet styres her (CSS: touch-action: pan-y på billed-slideren), så et vandret
  // swipe altid bladrer i billederne - aldrig i produkt-slideren og aldrig ind på produktet.
  // Lodrette swipes scroller siden som normalt, og et rigtigt tryk åbner stadig produktet.
  // touchmove lyttes kun på selve billed-sliderne (ikke hele siden), så scroll på resten af siden ikke bliver langsommere.
  var hhTraek = null;
  var hhSpaerKlik = 0;
  var hhFlyt = function (e) {
    var d = hhTraek;
    if (!d || d.s !== this || e.touches.length !== 1) return;
    var dx = e.touches[0].clientX - d.x;
    var dy = e.touches[0].clientY - d.y;
    if (!d.retning) {
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
      d.retning = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
      if (d.retning === 'x') d.s.classList.add('hh-traek');
    }
    if (d.retning !== 'x') return;
    if (e.cancelable) e.preventDefault();
    d.dx = dx;
    d.s.scrollLeft = d.start - dx;
  };
  var hhSlip = function () {
    var d = hhTraek;
    hhTraek = null;
    if (!d || d.retning !== 'x') return;
    hhSpaerKlik = Date.now();
    var s = d.s;
    var w = s.clientWidth || 1;
    var antal = s.querySelectorAll('[data-hover-slide-touch]').length;
    var fra = Math.round(d.start / w);
    var til = fra;
    // Et kort swipe (15 % af billedets bredde) er nok til at skifte billede
    if (Math.abs(d.dx) > w * 0.15) til = fra + (d.dx < 0 ? 1 : -1);
    til = Math.max(0, Math.min(antal - 1, til));
    var faerdig = function (e) {
      // "scrollend" fra selve trækket ignoreres - snap slås først til igen, når billedet står på plads
      if (e && Math.abs(s.scrollLeft - til * w) > 2) return;
      clearTimeout(s.hhSlut);
      s.removeEventListener('scrollend', faerdig);
      s.classList.remove('hh-traek');
    };
    s.addEventListener('scrollend', faerdig);
    s.hhSlut = setTimeout(faerdig, 800);
    s.scrollTo({ left: til * w, behavior: 'smooth' });
  };
  document.addEventListener('touchstart', function (e) {
    var kort = e.target.closest ? e.target.closest('.double__image') : null;
    if (kort) hhVisBilleder(kort);
    var s = e.target.closest ? e.target.closest('hover-images [data-hover-slider]') : null;
    if (!s || e.touches.length !== 1 || s.classList.contains('flickity-enabled')) {
      hhTraek = null;
      return;
    }
    if (!s.hhTouch) {
      s.hhTouch = true;
      s.addEventListener('touchmove', hhFlyt, { passive: false });
    }
    clearTimeout(s.hhSlut);
    hhTraek = { s: s, x: e.touches[0].clientX, y: e.touches[0].clientY, start: s.scrollLeft, retning: null, dx: 0 };
  }, { passive: true });
  document.addEventListener('touchend', hhSlip, { passive: true });
  document.addEventListener('touchcancel', hhSlip, { passive: true });
  // Et swipe på billedet må ikke åbne produktet
  document.addEventListener('click', function (e) {
    if (Date.now() - hhSpaerKlik < 600 && e.target.closest && e.target.closest('hover-images')) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
  document.addEventListener('focusin', function (e) {
    var kort = e.target.closest ? e.target.closest('.double__image') : null;
    if (kort) hhVisBilleder(kort);
  });
  // Telefon: prikkerne følger med, når man swiper mellem billederne
  document.addEventListener('scroll', function (e) {
    var s = e.target;
    if (!s || !s.matches || !s.matches('[data-hover-slider]') || !s.clientWidth) return;
    var hover = s.closest('hover-images');
    if (hover) hhPrikker(hover, Math.round(s.scrollLeft / s.clientWidth));
  }, true);
}
